module.exports = __webpack_public_path__ + "img/meikuang.41e6ebe.41e6ebe1.png";